import React from 'react'
import Bredcom from '../Bredcrumb/Main'
import FullMenu from '../Allmenus/FullMenu'
import PageSEO from '../SEO/PageSEO'
import Img from '../../assets/images/background/banner-image-2.jpg'

const BREADCRUMB_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://www.huqup380.com/' },
    { '@type': 'ListItem', position: 2, name: 'Menu', item: 'https://www.huqup380.com/menu' }
  ]
}

function Main() {
  return (
    <>
      <PageSEO
        title="Menu"
        description="Explore the full Huq Up menu — appetizers, biryanis, kababs, burgers, wraps, artisan pizzas, hookah (70+ flavors), specialty coffees & more. Dine-in or order online in Little Elm, TX."
        canonical="https://www.huqup380.com/menu"
        structuredData={BREADCRUMB_SCHEMA}
      />
      <Bredcom subtitle="Our Menu" title="DELICIOUS & AMAZING" Img={Img} />
      <FullMenu />
      {/* <Reservation /> */}
    </>
  )
}

export default Main